import React from 'react';
import PropTypes from 'prop-types';
import Sound from 'react-sound';

import DrumRollSoundPath from '../../../sounds/drumroll.mp3';
import WinnerSoundPath from '../../../sounds/winner.mp3';

function LotterySounds(props) {
  return (
    <div>
      <Sound
        url={DrumRollSoundPath}
        playStatus={props.drumRollSound}
        playFromPosition={0}
        onFinishedPlaying={() => props.startLottery(props.numberOfWinner)}
      />
      <Sound
        url={WinnerSoundPath}
        playStatus={props.winnerSound}
        playFromPosition={0}
        onFinishedPlaying={() => props.finishedWinAnimation()}
      />
    </div>
  );
}

LotterySounds.propTypes = {
  drumRollSound: PropTypes.string.isRequired,
  winnerSound: PropTypes.string.isRequired,
  numberOfWinner: PropTypes.number.isRequired,
  finishedWinAnimation: PropTypes.func.isRequired,
  startLottery: PropTypes.func.isRequired,
};

export default LotterySounds;



// WEBPACK FOOTER //
// ./src/views/pages/lottery/LotterySounds.js